import { OverflowMenuVertical } from '@carbon/icons-react'
import { HeaderContext } from 'app/_components/Editor/index'
import { Tooltip } from 'app/_components/Tooltip'
import { use, useMemo } from 'react'
import { twMerge } from 'tailwind-merge'
import styles from './styles.module.css'

export function ShowMore({
  toolbar,
  toolbarHeight,
}: {
  toolbar: HTMLDivElement | null
  toolbarHeight: number
}) {
  const [expanded, toggleExpanded] = use(HeaderContext)

  const rowHeight = useMemo(() => {
    const firstChild = toolbar?.firstElementChild as HTMLElement | undefined

    return firstChild?.offsetHeight ?? 0
  }, [toolbar])

  if (toolbarHeight <= rowHeight) return null

  return (
    <Tooltip content="Mehr">
      <button
        className={twMerge('button hover:bg-gray-20', styles.button)}
        data-active={expanded}
        type="button"
        onMouseDown={toggleExpanded}
      >
        <span className="sr-only">Mehr</span>
        <OverflowMenuVertical />
      </button>
    </Tooltip>
  )
}
